const LocalesActionTypes = {
  SET_LOCALE: 'SET_LOCALE',
};

export default LocalesActionTypes;
